import AuthProfile from "../../auth/services/model/AuthProfile";

interface ZapierWebhookData {
  company_id: number;
  company_name: string;
  file: string;
  date: string;
  user_name: string;
  user_email: string;
}

const ZAPIER_WEBHOOK_URL =
  "https://hooks.zapier.com/hooks/catch/20940997/uu678tk/";

export const sendZapierWebhook = async (
  data: ZapierWebhookData
): Promise<void> => {
  const params = new URLSearchParams({
    company_id: data.company_id.toString(),
    company_name: data.company_name,
    file: data.file,
    date: data.date,
    user_name: data.user_name,
    user_email: data.user_email,
  });

  await fetch(`${ZAPIER_WEBHOOK_URL}?${params.toString()}`, {
    method: "GET",
    mode: "no-cors",
  });
};

export const createWebhookData = (
  filePath: string,
  authProfile: AuthProfile
): ZapierWebhookData => {
  const fileName = filePath.split("/").pop() || filePath;
  const now = new Date();
  const formattedDate = now.toISOString().slice(0, 16).replace("T", " ");

  const fullName = authProfile.last_name
    ? `${authProfile.first_name} ${authProfile.last_name}`
    : authProfile.first_name;

  return {
    company_id: authProfile.employer.id,
    company_name: authProfile.employer.company_name,
    file: fileName,
    date: formattedDate,
    user_name: fullName,
    user_email: authProfile.email,
  };
};
